<template>
    <div class="vx-card p-8 flex flex-col gap-4">
        <vs-input class="border-grey-light w-full" type="text" v-model="appConditionTemplate.id_ref"
            :label="$t('admin.app-conditions-templates.id_ref')" :danger="appConditionTemplate.id_ref === ''"
            @input="$emit('input', appConditionTemplate)" />

        <vs-input class="border-grey-light w-full" type="text" v-model="appConditionTemplate.reference"
            :label="$t('admin.app-conditions-templates.reference')"
            :danger="appConditionTemplate.reference == ''" @input="$emit('input', appConditionTemplate)" />

        <LocalizedContent
            v-model="appConditionTemplate.languages"
            :fieldsDefinition="([
                { name: 'content', label: $t('admin.app-conditions-templates.content'), type: 'rich_textarea' },
            ])" 
        />

        <div class="flex items-center ml-0 gap-4 mt-5">
            <vs-button :disabled="!isValid" class="rounded-lg xs:w-full sm:w-auto" @click="save">
                {{ $t('resorts.touristic-objects.form.saveButton') }}
            </vs-button>
            <vs-button type="border" class="rounded-lg xs:w-full sm:w-auto text-primary" @click="$router.push('/admin/app-condition-templates')">
                {{ $t('resorts.touristic-objects.form.cancelButton') }}
            </vs-button>
        </div>
    </div>
</template>

<script>

import store from "@/modules/Shared/Store/store";
import loader from "@/modules/Shared/Mixins/loader";
import LocalizedContent from '@/modules/Shared/Components/form/LocalizedContent'
import AppConditionTemplateService from "@/modules/Admin/Services/AppConditionsService";

export default {
    name: "EditAppConditionTemplatePage",
    components: { LocalizedContent },
    mixins: [loader],
    data() {
        return {
            appConditionTemplate: {
                uuid: "",
                id_ref: "",
                reference: "",
                languages: [],
            },
            new: true,
        }
    },

    computed: {
        isValid() {
            return this.appConditionTemplate.id_ref && this.appConditionTemplate.reference
        }
    },

    async beforeRouteEnter(to, from, next) {
        try {
            const appConditionTemplate = await AppConditionTemplateService.getAppConditionTemplate(to.params.uuid);
            await store.dispatch('setRouteElement', appConditionTemplate)
            next(vm => {
                vm.appConditionTemplate = appConditionTemplate
                vm.new = false
            })
        } catch (error) {
            await store.dispatch('setRouteElement', null)
            next(vm => {
                vm.appConditionTemplate = {
                    uuid: to.params.uuid,
                    id_ref: "",
                    reference: "",
                    languages: [],
                }
            })
        }
    },
    async created() {

    },
    methods: {
        save() {
            this.loadAndNotify(async () => {
                if (this.new) {
                    
                    await AppConditionTemplateService.createAppConditionTemplate(this.$route.params.uuid, this.appConditionTemplate);
                } else {
                    await AppConditionTemplateService.updateAppConditionTemplate(this.appConditionTemplate.uuid, this.appConditionTemplate);
                }
                this.$router.push('/admin/app-condition-templates');
            })
        }
    }
};
</script>